import useSWR from 'swr';
import { AdminSettingsService } from '@/services/engine/admin-settings-service';
import type {
    AuditEventsPaginatedResponse,
    AuditEventsParams,
} from '@/types/admin-settings';

const CACHE_KEY = 'admin-audit-events';

export function useAuditEvents(params: AuditEventsParams = {}) {
    const {
        page = 1,
        size = 50,
        eventTypes,
        startDate,
        endDate,
        userIds,
    } = params;

    const { data, isLoading, error, mutate } =
        useSWR<AuditEventsPaginatedResponse>(
            [CACHE_KEY, page, size, eventTypes, startDate, endDate, userIds],
            () =>
                AdminSettingsService.getAuditEvents({
                    page,
                    size,
                    eventTypes,
                    startDate,
                    endDate,
                    userIds,
                }),
            { revalidateOnFocus: false },
        );

    return {
        events: data?.items ?? [],
        total: data?.page.totalItems ?? 0,
        isLoading,
        error,
        mutate,
    };
}
